import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: [
    '../../shared/Styles/public-page.css',
    './features.component.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeaturesComponent {
  public readonly featureIds = [1, 2, 3, 4, 5, 6];
}
